var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table"},_vm._l((_vm.matrix),function(row,rowIndex){return _c('div',{key:'row-' + rowIndex,staticClass:"container"},_vm._l((row),function(col,colIndex){return _c('Cell',{key:'col-' + colIndex,class:[
        (_vm.matrix[rowIndex][colIndex] == 'Click') ? 'click-btn' : '',
        (_vm.matrix[rowIndex][colIndex] == 'Cmd') ? 'cmd-btn' : '',
        (_vm.matrix[rowIndex][colIndex] == 'Order') ? 'order-btn' : '',
        (_vm.matrix[rowIndex][colIndex] == 'Verbal') ? 'verbal-btn' : '',
        (_vm.matrix[rowIndex][colIndex] == 'Post') ? 'post' : ''
      ],attrs:{"initialValue":_vm.matrix[rowIndex][colIndex],"title":_vm.titleMatrix[rowIndex][colIndex]}})}),1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }